const state = {
  modals : {},
  modalsID : [],
  modalActive : undefined,
}
const getters = {
  modals: state => {
    return state.modals
  },
  modalsID: state => {
    return state.modalsID
  },
  modalActive: state => {
    return state.modalActive
  },
}
const actions = {
  setModal({ rootState, commit, dispatch }, { modal_id, id, payload, callback = {}, module = 'self' }) {
    commit('SET_MODAL',{ modal_id, id, payload, callback, module })
    commit('SET_MODAL_ID',{ modal_id })
    commit('SET_MODAL_ACTIVE',{ modal_id })
    if (module == 'self') { // tell other
      dispatch('design/modals/setModal', { modal_id, id, payload, module: rootState.module }, { root: true })
    }
  },
  setModalActive({ rootState, commit, dispatch }, { modal_id = '', module = 'self' }) {
    commit('SET_MODAL_ACTIVE',{ modal_id })
    if (module == 'self') { // tell other
      dispatch('design/modals/setModalActive', { modal_id, module: rootState.module }, { root: true })
    }
  },
  callback({ rootState, commit, dispatch }, { key, func, data, clear = false, module = 'self' }) {
    state.modals[key] && state.modals[key].callback[func] && state.modals[key].callback[func](data);
    if (clear) {
      commit('CLEAR',{ key })
      if (module == 'self') { // tell other
        dispatch('design/modals/callback', { key, func, data, clear, module: rootState.module }, { root: true })
      }
    }
  },
}
const mutations = {
  SET_MODAL(state, { modal_id, id, payload, callback, module }) {
    state.modals[modal_id] = { modal_id, id, payload, callback, module } 
  },
  SET_MODAL_ID(state, { modal_id }) {
    state.modalsID.push(modal_id);
  },
  SET_MODAL_ACTIVE(state, { modal_id }) {
    state.modalActive = modal_id;
  },
  CLEAR(state, { key }) {
    delete state.modals[key];
    if (state.modalsID.includes(key)) {
      state.modalsID.splice(state.modalsID.indexOf(key), 1);
    }
    if (state.modalActive == key) {
      state.modalActive = state.modalsID.length ? state.modalsID[state.modalsID.length - 1] : undefined;
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};